import React, { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";
import RegistroEgresosTab from "../components/RegistroEgresosTab";
import RegistroIngresosTab from "../components/RegistroIngresosTab";
import RegistroItemsTab from "../components/RegistroItemsTab";
import ReportesTab from "../components/ReportesTab";
import { CAJA_PROYECTOS_COLOR } from "../theme";

const TABS = ["Registro Egresos", "Registro de Ingresos", "Registro de Items", "Reportes"];

const CajaProyectosPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <DashboardLayout>
      <PageHeader title="Caja Proyectos" subtitle="Registro de egresos" showBack={false} />
      <Box sx={{ p: 1 }}>
        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden" }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 34,
              "& .MuiTab-root": { minHeight: 34, py: 0.5, fontSize: 12, fontWeight: 700, textTransform: "none" },
              "& .MuiTab-root.Mui-selected": { color: CAJA_PROYECTOS_COLOR },
              "& .MuiTabs-indicator": { bgcolor: CAJA_PROYECTOS_COLOR },
            }}
          >
            {TABS.map((label) => (
              <Tab key={label} label={label} />
            ))}
          </Tabs>
        </Paper>

        {tab === 0 && <RegistroEgresosTab />}
        {tab === 1 && <RegistroIngresosTab />}
        {tab === 2 && <RegistroItemsTab />}
        {tab === 3 && <ReportesTab />}
      </Box>
    </DashboardLayout>
  );
};

export default CajaProyectosPage;
